import React, { useState } from "react";
import PermissionButton from "../../shared/PermissionButton";
import SubjectForm from "./SubjectForm";

const CreateSubject = ({ name }) => {
  return (
    <div className="arr-content">
      <div className="arr-heading">
        <h1>Create Subject</h1>
        <div className="arr-btns-group">
          <PermissionButton
            moduleName={"Subjects Setup"}
            widgetName={name}
            header={"Create Subject"}
            activityName={"insert-subject"}
          />
        </div>
      </div>
      
      <div className="arr-form-center">
        <SubjectForm type={"create"} />
      </div>
    </div>
  );
};

export default CreateSubject;
